// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Select } from 'antd';
import React, { CSSProperties, ReactElement, ReactNode } from 'react';

import './Option.scss';

export interface OptionProps {
    children: ReactNode;
    value: any;
    disabled?: boolean;
    key?: string;
    style?: CSSProperties;
    title?: string;
    className?: string;
}

export const Option = React.memo(
    ({ children, ...props }: OptionProps): ReactElement => (
        <Select.Option className={classList('th-select__option')} {...props}>
            {children}
        </Select.Option>
    ),
);
(Option as any).isSelectOption = true;
